/** @format */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface ContentEditorState {
  action?: string;
  itemId?: string;
  maxStages?: number;
  showModal: boolean;
  stage: number;
  status: "idle" | "loading" | "failed";
  isLoading: boolean;
}

export const initialState: ContentEditorState = {
  action: undefined,
  itemId: undefined,
  stage: 1,
  showModal: false,
  status: "idle",
  maxStages: 1,
  isLoading: false,
};

export const contentEditorSlice = createSlice({
  name: "contentEditor",
  initialState,
  reducers: {
    setAction: (state, action: PayloadAction<string>) => {
      state.action = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setShowModal: (state, action: PayloadAction<boolean>) => {
      state.showModal = action.payload;
    },
    setStage: (state, action: PayloadAction<number>) => {
      state.stage = action.payload;
    },
    setMaxStages: (state, action: PayloadAction<number>) => {
      state.maxStages = action.payload;
    },
    setShowContentEditor: (
      state,
      action: PayloadAction<{
        action: string;
        itemId?: string;
        stage?: number;
        maxStages?: number;
      }>,
    ) => {
      state.itemId = action.payload.itemId;
      state.action = action.payload.action;
      state.showModal = true;
      state.stage = action.payload.stage ?? 1;
      state.maxStages = action.payload.maxStages ?? 1;
      state.isLoading = false;
    },
  },
});

export const {
  setAction,
  setIsLoading,
  setShowModal,
  setShowContentEditor,
  setStage,
} = contentEditorSlice.actions;
export const selectAction = () => (state: RootState) =>
  state.contentEditor.action;
export const selectShowModal = () => (state: RootState) =>
  state.contentEditor.showModal;
export const selectItemId = () => (state: RootState) =>
  state.contentEditor.itemId;
export const selectStage = () => (state: RootState) =>
  state.contentEditor.stage;
export const selectIsLoading = () => (state: RootState) =>
  state.contentEditor.isLoading;
export const selectMaxStages = () => (state: RootState) =>
  state.contentEditor.maxStages;
export default contentEditorSlice.reducer;
